import { modifier } from 'ember-modifier';

export interface OnWindowSignature {
  Args: {
    Positional: [eventName: string, callback: () => void];
  };
  Element: HTMLElement;
}

const OnWindowModifier = modifier(
  (
    element: OnWindowSignature['Element'],
    [eventName, callback]: OnWindowSignature['Args']['Positional'],
  ) => {
    window.addEventListener(eventName, callback);

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    return () => {
      window.removeEventListener(eventName, callback);
    };
  },
);

export default OnWindowModifier;
